export default __webpack_public_path__ + "static/media/emptyCalendar.73592b54.png";